import { DEFAULT_SLOT, Provider, TextContext } from 'react-aria-components';
import { type PropsWithChildren } from 'react';

export function ClearTextSlots({ children }: PropsWithChildren) {
  return (
    <Provider
      values={[
        [
          TextContext,
          {
            slots: {
              [DEFAULT_SLOT]: {},
            },
          },
        ],
      ]}
    >
      {children}
    </Provider>
  );
}
